// i18n/lang/kyDate.js
import { ru } from 'date-fns/locale';

const months = [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
];

const monthsGenitive = [
    'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
    'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
];

const days = [
    'Жекшемби', 'Дүйшөмбү', 'Шейшемби', 'Шаршемби', 'Бейшемби', 'Жума', 'Ишемби'
];

const daysShort = [
    'Жек', 'Дүй', 'Шей', 'Шар', 'Бей', 'Жум', 'Ише'
];

export const ky = {
    ...ru,
    code: 'ky',
    localize: {
        ...ru.localize,
        month: (index, options) => {
            const values = {
                formatting: months,
                standalone: months
            };
            if (options?.context === 'standalone' && monthsGenitive[index]) {
                return monthsGenitive[index];
            }
            return values[options?.context ?? 'formatting'][index];
        },
        day: (index, options) => {
            const values = {
                formatting: days,
                standalone: days
            };
            return values[options?.context ?? 'formatting'][index];
        },
        dayPeriod: ru.localize.dayPeriod,
    },
    formatLong: {
        ...ru.formatLong,
    }
};